<template>
  <v-app>
    <pages-core-app-bar />

    <pages-core-view />

    <pages-core-footer />
    <loader />
  </v-app>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'PagesIndex',

    components: {
      Loader: () => import('../../components/Loader'),
      PagesCoreAppBar: () => import('./components/core/AppBar'),
      PagesCoreFooter: () => import('./components/core/Footer'),
      PagesCoreView: () => import('./components/core/View'),
    },
    computed: {
      ...mapState(['darkMode']),
    },
    created () {
      this.$vuetify.theme.dark = true
    },

    beforeDestroy () {
      this.$vuetify.theme.dark = this.darkMode
    },
  }
</script>
